(() => {
	angular.module('main').directive('anonymousNavbar', anonymousNavbar);

	anonymousNavbar.$inject = [];

	function anonymousNavbar() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: require('./anonymousNavbar.component.html'),
			controller: 'LoginController',
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/navigation/anonymous-navbar/anonymousNavbar.component.js